import React from "react";

const MarginTop = () => {
  return (
    <>
      <section
        id="home"
        className="dtr-section dtr-section-with-bg dtr-hero-section-top-padding bg-blue"
        style={{
          backgroundImage:
            "url()",
          paddingTop: "150px",
        }}
      ></section>
    </>
  );
};

export default MarginTop;

